import(/* webpackMode: "eager" */ "/builds/magic.ai/frontend/magicsquare/apps/store-web/app/error.tsx");
